//BaseIconButton.tsx

import { IconButton, IconButtonProps } from '@mui/material'
import React from 'react'

export default function BaseIconButton(props: IconButtonProps) {
  return (
    <IconButton
      {...props}
      sx={{
        borderRadius: '4px',
        color: 'button.color',
        background: 'button.background',
        backgroundColor: 'button.background',
        fontSize: '24px',
        height: '36px',
        width: '36px',
        boxSizing: 'border-box',
        ...props.sx,
      }}
    />
  )
}
